import {gql} from "apollo-boost"

export const CREATE_REDEEM = gql`
mutation CreateRedeem($data: RedeemInput!) {
  createRedeem(data: $data) {
    status
    msg
    tag
    redeem {
      id
      rewardName
      rewardType
      no
      status
      point
      dateYmd
      percent
      shop {
        id
        name
      }
      userConfirm {
        id
        name
        lastname
        phone
      }
      reward {
        id
        name
        pointMin
        percent
        remainUser
      }
      createdBy {
           id
        firstName
        lastName
        phone
      }
      updatedBy {
        id
        firstName
        lastName
        phone
      }
      createdAt
      updatedAt
    }
  }
}
`